import { render, staticRenderFns } from "./pay-multiple.vue?vue&type=template&id=6b7ad248&scoped=true&"
import script from "./pay-multiple.vue?vue&type=script&setup=true&lang=js&"
export * from "./pay-multiple.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pay-multiple.vue?vue&type=style&index=0&id=6b7ad248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ad248",
  null
  
)

export default component.exports